import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Grid } from '@mui/material'
import React from 'react'
import { DevicesTable } from './DevicesTable'
import { SummaryGraphic } from './SummaryGraphic'

export const InstallationFormOverview: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <Paper title={t('installation.summaryTable.title')}>
      <Grid container columnSpacing={6} rowSpacing={3}>
        <Grid item xs={12} lg={6}>
          <Box pl={[2, 0]} pr={2}>
            <SummaryGraphic />
          </Box>
        </Grid>
        <Grid item xs={12} lg={6}>
          <DevicesTable />
        </Grid>
      </Grid>
    </Paper>
  )
}
